import { FixedNavbarBtnProps } from "@/types/ui-kit/buttons";
import { getDomainUrl } from "@/utils/getDomainUrl";
import { pushToDataLayer } from "@/utils/pushToDataLayer";
import { useRouter } from "next-translate-routes";
import Image from "next/image";
import React from "react";

export const FixedNavbarShareButton: React.FC<FixedNavbarBtnProps> = ({ title }) => {
  const router = useRouter();
  const currentURL = getDomainUrl(router.asPath);

  const shareData = {
    title: title ?? "Magazín Reportér",
    url: currentURL,
  };

  const sharePost = async (e: React.MouseEvent<HTMLElement>) => {
    if (navigator.canShare(shareData)) {
      e.preventDefault();
      try {
        await navigator.share(shareData);
      } catch (error) {
        console.log(error);
      }
    }
    // article_interaction (share)
    pushToDataLayer({
      event: "article_interaction",
      interaction_type: "share",
      interaction_option: title ?? "Magazín Reportér",
    });
  };

  return (
    <li className="w-full max-w-[78px] portrait:h-full">
      <span
        className="flex cursor-pointer flex-col items-center dark:text-white portrait:py-2 portrait:text-xs landscape:px-1.5 landscape:py-1.5 landscape:text-4xs"
        onClick={sharePost}
      >
        <Image
          src="/assets/images/icons/new-share.svg"
          alt="Share Icon"
          width={20}
          height={20}
          className="mb-1 dark:invert landscape:h-[16px] landscape:w-[16px]"
        />
        Sdílet
      </span>
    </li>
  );
};
